import { FieldValidationNegativeIcon, FieldValidationPositiveIcon } from "@components/icon";
import { PrRetirementSavingsCompanyEntity, } from "@odata/GeneratedEntityTypes";

import { DATABOX_REST_URL } from "../../../constants";
import { Status } from "../../../enums";
import customFetch from "../../../utils/customFetch";
import { FormStorage } from "../../../views/formView/FormStorage";

export const checkDataBoxUrl = `${DATABOX_REST_URL}/check/`;


export const validateDataBox = async (storage: FormStorage): Promise<void> => {
    const dataBoxBc = storage.data.bindingContext.navigate(PrRetirementSavingsCompanyEntity.DataBoxId);
    const dataBoxId = storage.getValue(dataBoxBc);
    const error = await storage.validateField(dataBoxBc);
    if (!error && dataBoxId) {
        storage.setAdditionalFieldData(dataBoxBc, "isBusy", true);
        storage.refreshField(dataBoxBc.getPath());

        const res = await customFetch(`${checkDataBoxUrl}/${dataBoxId}`);

        const validationResult = res.ok ? {
            status: Status.Success,
            message: storage.t("RetirementSavingsCompany:Form.DataboxValidationSuccess"),
            icon: FieldValidationPositiveIcon
        } : {
            status: Status.Warning,
            message: storage.t("RetirementSavingsCompany:Form.DataboxValidationError"),
            icon: FieldValidationNegativeIcon
        };

        storage.setAdditionalFieldData(dataBoxBc, "isBusy", false);
        storage.setAdditionalFieldData(dataBoxBc, "validationResult", validationResult);
    } else {
        storage.setAdditionalFieldData(dataBoxBc, "validationResult", null);
    }
    storage.refreshField(dataBoxBc.getPath());
};